// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"5cb0d2b8","103":"e73f0a17","162":"668b4459","222":"275d1d96","355":"0ad3c3c5","563":"5a9e6000","973":"41b017c4"}[chunkId] + ".chunk.js";
};